import { useI18n } from "vue-i18n";

export default class RouteHelper {
    public static getLink(path: string): string {
        const i18n = useI18n();

        return `/${i18n.locale.value}/${path}`;
    }
}